import React, { useState, useEffect } from "react";
import dashboardclasses from "../dashboard.module.css";
import "bootstrap/dist/css/bootstrap.min.css";
import "react-bootstrap-table-next/dist/react-bootstrap-table2.css";
import "react-bootstrap-table2-paginator/dist/react-bootstrap-table2-paginator.min.css";
import BootstrapTable from "react-bootstrap-table-next";
import paginationFactory from "react-bootstrap-table2-paginator";
import { FaRegEdit } from "react-icons/fa";
import { MdDelete } from "react-icons/md";
import "../../App.css";
import { Services } from "../../Services";
import { toast } from "react-toastify";
import Addwarehouse from "./Addwarehouse";
import { css } from "@emotion/react";
import ScaleLoader from "react-spinners/ScaleLoader";
import { useNavigate, useSearchParams } from "react-router-dom";
import Layout from "../../Components/Layout/layout";

function Warehouse() {
    const Navigate = useNavigate();
    const [params] = useSearchParams();
    const [id, setid] = useState();
    const [loading, setLoading] = useState(true);
    const [pageCount, setpageCount] = useState(1);
    const [category, setCategory] = useState(false);
    const [tableLoad, setTableLoad] = useState(false);

    const [editable, setEditable] = useState(false);
    const [categoryItems, setCategoryItems] = useState([]);
    const [categorysearchItems, setCategorySearchItems] = useState([]);
    const token = { Authorization: `token ${sessionStorage.getItem("token")}` };
    const categoryHandler = () => {
        setCategory((prev) => !prev);
    };
    const headerstyles = {
        color: "#707275",
        fontWeight: 700,
        fontSize: "0.8rem",
    };
    const override = css`
        display: block;
        margin: 0 auto;
        border-color: red;
    `;
    useEffect(() => {
        getcategories();
        if (params.get("page")) {
            setpageCount(Number(params.get("page")));
            // console.log(typeof params.get("page"));
        }
        // eslint-disable-next-line
    }, []);
    useEffect(() => {
        let timer = setTimeout(() => {
            setTableLoad(false);
        }, 150);
        return () => {
            clearTimeout(timer);
        };
        // eslint-disable-next-line
    }, [categorysearchItems]);
    const getcategories = () => {
        Services.getwarehouses("GET", null, token)
            .then((res) => {
                setLoading(false);
                console.log("1", res);
                if (res.Status === 1) {
                    setCategoryItems(res.warehouses);
                    setCategorySearchItems(res.warehouses);
                } else if (res.Status === 0) {
                    toast.error(`${res.Message}`, {
                        position: "top-center",
                        autoClose: 1000,
                        hideProgressBar: true,
                        closeOnClick: true,
                        pauseOnHover: true,
                        draggable: true,
                        progress: undefined,
                    });
                    if (res.Message === "Token expired") {
                        Navigate("/");
                    }
                }
            })
            .catch((err) => {
                // alert(err);
                alert("something went wrong please try again");
                console.log(err);
            });
    };

    const edithandler = (e) => {
        console.log(e.currentTarget.getAttribute("id"));
        setid(e.currentTarget.getAttribute("id"));
        setEditable(true);
        setCategory(true);
    };

    const deleteHandler = (e) => {
        if (window.confirm("are you sure you want to delete ")) {
            Services.DeleteWarehouse(
                "DELETE",
                null,
                token,
                e.currentTarget.getAttribute("id")
            )
                .then((res) => {
                    if (res.Status === 1) {
                        getcategories();
                        toast.success(`${res.Message}`, {
                            position: "top-center",
                            autoClose: 1000,
                            hideProgressBar: true,
                            closeOnClick: true,
                            pauseOnHover: true,
                            draggable: true,
                            progress: undefined,
                        });
                    } else if (res.Status === 0) {
                        toast.error(`${res.Message}`, {
                            position: "top-center",
                            autoClose: 1000,
                            hideProgressBar: true,
                            closeOnClick: true,
                            pauseOnHover: true,
                            draggable: true,
                            progress: undefined,
                        });
                    }
                    if (res.Message === "Token expired") {
                        Navigate("/");
                    }
                })
                .catch((err) => {
                    // alert(err);
                    alert("something went wrong please try again");
                    console.log(err);
                });
        }
    };
    const ActionFormatter = (cell, cellcontent) => {
        console.log(cellcontent);
        return (
            <div className={dashboardclasses.tablebtns}>
                <button onClick={edithandler} id={cellcontent.warehouseId}>
                    <FaRegEdit size={18} />
                </button>
                <button onClick={deleteHandler} id={cellcontent.warehouseId}>
                    <MdDelete size={18} />
                </button>
            </div>
        );
    };
    const statusFormatter = (cell, cellcontent) => {
        let classname =
            cell === 1
                ? dashboardclasses["status_active"]
                : dashboardclasses["status_inactive"];
        return (
            <span className={classname} style={{ textAlign: "center" }}>
                {cell === 1 ? "Active" : "Inactive"}
            </span>
        );
    };

    const columns = [
        {
            dataField: "warehousename",
            text: "NAME",
            sort: false,
            headerStyle: (colum, colIndex) => {
                return { ...headerstyles };
            },
        },
        {
            dataField: "Address",
            text: "ADDRESS",
            sort: false,
            formatter: (cell, cellcontent) => {
                if (cellcontent.address1.length === 0) {
                    return "NA";
                } else {
                    return (
                        <p style={{ margin: "0" }}>
                            {cellcontent.address1}
                            <br />
                            {cellcontent.address2.length > 0 &&
                                cellcontent.address2}
                        </p>
                    );
                }
            },
            headerStyle: (colum, colIndex) => {
                return { ...headerstyles };
            },
        },
        {
            dataField: "city",
            text: "CITY",
            sort: false,
            headerStyle: (colum, colIndex) => {
                return { ...headerstyles };
            },
        },
        {
            dataField: "GSTNumber",
            text: "GST NUMBER",
            sort: false,
            headerStyle: (colum, colIndex) => {
                return { ...headerstyles };
            },
        },
        {
            dataField: "PANNumber",
            text: "PAN NUMBER",
            sort: false,
            headerStyle: (colum, colIndex) => {
                return { ...headerstyles };
            },
        },
        {
            dataField: "status",
            text: "STATUS",
            sort: false,
            formatter: statusFormatter,
            headerStyle: (colum, colIndex) => {
                return { ...headerstyles };
            },
        },

        {
            dataField: "ACTIONS",
            text: "ACTIONS",
            sort: false,
            formatter: ActionFormatter,
            headerStyle: (colum, colIndex) => {
                return { ...headerstyles, width: "100px" };
            },
        },
    ];
    const pagination = paginationFactory({
        page: pageCount,
        sizePerPage: 8,
        lastPageText: ">>",
        firstPageText: "<<",
        nextPageText: ">",
        prePageText: "<",
        hideSizePerPage: true,
        showTotal: true,
        alwaysShowAllBtns: true,
        onPageChange: function (page, sizePerPage) {
            window.scrollTo({ top: 10, behavior: "instant" });
            Navigate(`/Warehouse?page=${page}`);
        },
        onSizePerPageChange: function (page, sizePerPage) {
            console.log("page", page);
            console.log("sizePerPage", sizePerPage);
        },
    });
    const defaultSorted = [
        {
            dataField: "name",
            order: "desc",
        },
    ];
    const searchHandler = (e) => {
        setTableLoad(true);
        Navigate(`/Warehouse?page=${1}`);
        setpageCount(1);
        const search = categoryItems.filter((item) =>
            item.warehousename
                .toLowerCase()
                .includes(e.target.value.toLowerCase())
        );
        console.log(search);
        setCategorySearchItems(search);
    };
    const emptyDataMessage = () => {
        return "No Data to Display";
    };
    return (
        <>
            {category && (
                <Addwarehouse
                    setmodal={setCategory}
                    editable={editable}
                    id={id}
                    setEditable={setEditable}
                    getCategories={getcategories}
                    setpageCount={setpageCount}
                    tableload={setTableLoad}
                />
            )}

            <Layout
                className={dashboardclasses["dashboard-wrapper"]}
                Active={"Warehouse"}>
                <div className={dashboardclasses.CategoryWrapper}>
                    <h3>Warehouse</h3>

                    {loading ? (
                        <div className={dashboardclasses["loader"]}>
                            <ScaleLoader
                                color={"black"}
                                loading={true}
                                css={override}
                                size={150}
                            />
                        </div>
                    ) : (
                        <>
                            <div
                                className={
                                    dashboardclasses["category-form-two"]
                                }>
                                <input
                                    type={"text"}
                                    placeholder="search by Name"
                                    onChange={searchHandler}
                                />

                                <button onClick={categoryHandler}>
                                    + Add Warehouse
                                </button>
                            </div>
                            {tableLoad ? (
                                <div className={dashboardclasses["loader"]}>
                                    <ScaleLoader
                                        color={"black"}
                                        loading={true}
                                        css={override}
                                        size={150}
                                    />
                                </div>
                            ) : (
                                <div className="category-table">
                                    <BootstrapTable
                                        bootstrap4
                                        keyField="id"
                                        data={categorysearchItems}
                                        columns={columns}
                                        defaultSorted={defaultSorted}
                                        pagination={pagination}
                                        noDataIndication={emptyDataMessage}
                                        wrapperClasses="table-responsive"
                                    />
                                </div>
                            )}
                        </>
                    )}
                </div>
            </Layout>
        </>
    );
}

export default Warehouse;
